// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3uBSg","detailsBorder":"styles_detailsBorder__3usEf"};